export default "__VITE_ASSET__0140ce74__"